import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "../CSS/store.css";
import Navbar from "../COMPONENT/Navbar/Navbar";
import CategoryCard from "../COMPONENT/Categorycard/CategoryCard";
import ProductCard from "../COMPONENT/ProductCard/ProductCard";
import Footer from "../COMPONENT/Footer/Footer";
import Loader from "../COMPONENT/Loader";
import Notfound from "../PAGES/NotFound";

import { useDispatch } from "react-redux";
import { setProducts, setURL } from "../store/storeDataSlice";

import img from "../Images/default.png";
import Wp from "../Images/wp.png"

function Store() {
  const { name } = useParams();
  const [loading, setLoading] = useState(false);
  const [isLinkExist, setIsLinkExist] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState(false);

  const openWhatsApp = () => {
    if (data && data.customization && data.customization[0].whatsappNumber) {
      const phoneNumber = `+91${data.customization[0].whatsappNumber}`;
      const message = 'Hello, Bazaar.com!';
  
      const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        message
      )}`;
  
      window.open(url, '_blank');
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_API}/get-store`,
          { businessLink: name }
        );
        setLoading(false);
        if (response.data.message === "Invalid URL") {
          setIsLinkExist(false);
        } else if (response.data.message === "Valid URL") {
          setIsLinkExist(true);
          setData(response.data.data);
          dispatch(setProducts(response.data.data));
          dispatch(setURL(name));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [name, dispatch]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {isLinkExist ? (
            <>
              <Navbar />
              <div className="container">
                <div className="banner-container">
                  <img
                    src={
                      data && data.customization && data.customization[0].image
                        ? `${process.env.REACT_APP_BANNER_IMAGE_PATH}${data.customization[0].image}`
                        : img
                    }
                    alt="Banner"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "10px",
                    }}
                  />
                </div>
                {/* -----------------------------Categories ----------------------- */}
                <div className="category-header">
                  <h2>Our Categories</h2>
                  <p>Elevate Your Choices with Us</p>
                </div>

                <CategoryCard />
                {/* -----------------------------Product ----------------------- */}
                <div className="product-header">
                  <h2>
                    Explore Our{" "}
                    {data &&
                      data.customization &&
                      data.customization[0].businessType}
                  </h2>
                  <p>Unveiling a World of Excellence and Choice</p>
                </div>
                <ProductCard />
              </div>
              <Footer />
              {data &&
                data.customization &&
                data.customization[0].whatsappNumber && (
                  <div className="chatButton" onClick={openWhatsApp}>
                    <img src={Wp} className="wpImg" alt="WhatsApp" />
                  </div>
                )}
            </>
          ) : (
            <Notfound />
          )}
        </>
      )}
    </>
  );
}

export default Store;
